/**
 * PATH: apps/quote/src/components/builder/panels/context-panel/TabButton.tsx
 * PURPOSE: Small tab button for context panel sub-tabs
 */

import { cn } from '@/lib/utils'

export type ContextTab = 'files' | 'emails' | 'drawings'

interface TabButtonProps {
  tab: ContextTab
  currentTab: ContextTab
  label: string
  icon: React.ComponentType<{ className?: string }>
  count?: number
  onClick: () => void
}

export default function TabButton({
  tab,
  currentTab,
  label,
  icon: Icon,
  count,
  onClick,
}: TabButtonProps) {
  const isActive = tab === currentTab
  return (
    <button
      onClick={onClick}
      className={cn(
        'flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
        isActive
          ? 'bg-blue-600 text-white'
          : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800'
      )}
    >
      <Icon className="w-3.5 h-3.5" />
      <span>{label}</span>
      {count !== undefined && count > 0 && (
        <span className={cn(
          'px-1 py-0.5 text-[10px] rounded-full',
          isActive ? 'bg-blue-500 text-white' : 'bg-slate-200 dark:bg-slate-700'
        )}>
          {count}
        </span>
      )}
    </button>
  )
}
